import { useQuery } from '@tanstack/react-query';
import { GetAllTestimonials } from '../api/api';

export const useGetAllTestimonial = () => {
  return useQuery({
    queryKey: ['testimonial'],
    queryFn: async () => {
      const { data, error } = await GetAllTestimonials();
      if (error) throw new Error(error);
      return data;
    },
  });
};